import { NextStageOptionsType } from '@jarvis/shell-commons/dist/interface/v1/serviceRouting/types'

import { AtLeastOnePartial } from '@/types/type-handlers'
import {
  OnboardingDirectorDeclinedResult,
  OnboardingDirectorErrorInfo,
  OnboardingDirectorFailureResult,
  OnboardingDirectorIneligibleResult,
  OnboardingDirectorOutput,
  OnboardingDirectorResult,
  OnboardingDirectorSuccessResult,
} from '@/utils/dispatch-next-stage/types'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export function dispatchNextStage(
  result: OnboardingDirectorDeclinedResult,
): void
export function dispatchNextStage(
  result: OnboardingDirectorIneligibleResult,
): void
export function dispatchNextStage(
  result: OnboardingDirectorSuccessResult,
  output?: AtLeastOnePartial<OnboardingDirectorOutput>,
  options?: NextStageOptionsType,
): void
export function dispatchNextStage(
  result: OnboardingDirectorFailureResult,
  errorInfo: OnboardingDirectorErrorInfo,
): void

export function dispatchNextStage(
  result: OnboardingDirectorResult,
  additionalPayload?: Record<string, object | string>,
  options?: NextStageOptionsType,
) {
  const { v1 } = getCommonsNorthboundAPIs()

  const outputPayload =
    result === 'success' && additionalPayload
      ? { output: additionalPayload }
      : undefined

  const errorInfoPayload =
    result === 'failure' ? { errorInfo: additionalPayload } : undefined

  v1.store.state.onboarding?.nextStage?.(
    {
      ...outputPayload,
      ...errorInfoPayload,
      result,
      xCorrelationId: v1.store.state.onboarding.sessionContext.xCorrelationId,
    },
    options,
  )
}
